// extracted by mini-css-extract-plugin
module.exports = {"toggle":"ToggleAnimation_toggle__19Nfv","sticks":"ToggleAnimation_sticks__Qf3Io","dot":"ToggleAnimation_dot__HNpFx","toggleIsActive":"ToggleAnimation_toggleIsActive__22CtQ"};